import React from 'react';
import { motion } from 'framer-motion';

const Products = () => {
  const categories = [
    { 
      title: "Sunglasses", 
      img: "https://images.unsplash.com/photo-1572635196237-14b3f281503f?q=80&w=2080&auto=format&fit=crop", 
      letter: "S",
      span: "lg:col-start-2 lg:row-start-1"
    },
    { 
      title: "Gift Vouchers", 
      img: "https://images.unsplash.com/photo-1549463591-24c1882747a8?q=80&w=2070&auto=format&fit=crop", 
      letter: "G",
      span: "lg:col-start-3 lg:row-start-1"
    },
    { 
      title: "Spectacles", 
      img: "https://images.unsplash.com/photo-1591076482161-42ce6da69f67?q=80&w=2070&auto=format&fit=crop", 
      letter: "S",
      span: "lg:col-start-1 lg:row-start-2"
    },
    { 
      title: "Contact Lenses", 
      img: "https://images.unsplash.com/photo-1617469767053-d3b508a0d182?q=80&w=2070&auto=format&fit=crop", 
      letter: "L",
      span: "lg:col-start-2 lg:row-start-2"
    },
    { 
      title: "Accessories", 
      img: "https://images.unsplash.com/photo-1614715838608-dd527c46231d?q=80&w=1978&auto=format&fit=crop", 
      letter: "A",
      span: "lg:col-start-3 lg:row-start-2"
    }
  ];

  return (
    <section id="products" className="py-24 bg-white font-poppins">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Balanced 3-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
          
          {/* Header Card */}
          <div className="lg:col-start-1 lg:row-start-1 p-10 flex flex-col justify-center space-y-6">
            <div className="inline-block">
              <h2 className="text-4xl lg:text-5xl font-black text-slate-800 tracking-tight mb-2">
                Our Products
              </h2>
              <div className="w-16 h-1 bg-syana-blue-600 rounded-full"></div>
            </div>
            <p className="text-slate-500 text-sm lg:text-base leading-relaxed font-medium">
              Find your perfect fit from the widest range of the world’s best eye care and hearing care brands available in Sri Lanka.
            </p>
          </div>

          {/* Product Category Tiles */}
          {categories.map((cat, i) => (
            <motion.div 
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`group relative overflow-hidden bg-slate-50/30 border border-slate-100 rounded-3xl h-64 flex items-center justify-between p-8 hover:bg-white hover:shadow-2xl hover:shadow-slate-200/50 transition-all duration-500 cursor-pointer ${cat.span}`}
            >
              {/* Background Initial (Subtle) */}
              {cat.letter && (
                <div className="absolute top-0 left-0 transition-all duration-700 group-hover:scale-125 opacity-5 group-hover:opacity-10 pointer-events-none">
                  <span className="text-[14rem] font-black leading-none text-slate-900 select-none">
                    {cat.letter}
                  </span>
                </div>
              )}

              {/* Product Info */}
              <div className="relative z-10 space-y-3">
                <h3 className="text-2xl font-bold text-syana-blue-900 tracking-tight leading-tight">
                  {cat.title}
                </h3>
                <div className="space-y-1">
                  <span className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400 group-hover:text-syana-blue-600 transition-colors">View All</span>
                  <div className="w-6 h-[1.5px] bg-syana-blue-600 transition-all group-hover:w-full"></div>
                </div>
              </div>

              {/* Product Image in Offset Box Frame */}
              <div className="relative w-1/2 h-full flex items-center pt-4">
                <div className="absolute inset-0 bg-white shadow-xl shadow-slate-200/50 rounded-2xl opacity-0 group-hover:opacity-100 group-hover:translate-x-2 group-hover:-translate-y-2 transition-all duration-500 -z-10"></div>
                <div className="w-full h-48 bg-white rounded-2xl shadow-sm border border-slate-50 flex items-center justify-center p-4 overflow-hidden relative">
                   <img 
                    src={cat.img} 
                    alt={cat.title} 
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 drop-shadow-lg"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Products;
